export const SETTICKETSCOUNT = "SETTICKETSCOUNT";
export const SETOPENTICKETS = "SETOPENTICKETS";
export const SETTICKETSCOUNTBYPRIORITY = "SETTICKETCOUNTSBYPRIORITY";
export const SETTICKETSCOUNTBYCATEGORY = "SETTICKETCOUNTSBYCATEGORY";
export const SETTOTALLOGWORKMONTHWISE = "SETTOTALLOGWORKMONTHWISE";
export const SUPPORTDESKDASHBOARDCLEARDOC = "SUPPORTDESKDASHBOARDCLEARDOC";